export default function isAre(count) {
  return !count || count > 1 ? 'are' : 'is';
}
